import * as React from "react";
import { toast } from "react-toastify";
import { useCurrentSnapshotCitation } from "@/modules/snapshots/contexts/useCurrentSnapshotCitation";
import { useGetBusinessReportOutcomeQuery } from "@/modules/snapshots/businessReports.api";
import { SnapshotGridPortal } from "@/modules/snapshots/grid/portal";

export const SnapshotCitationDrawer = () => {
  const { currentSnapshotCitation, setCurrentSnapshotCitation } = useCurrentSnapshotCitation();
  const snapshotOutcomeId = currentSnapshotCitation?.snapshotOutcomeId;

  const { data: outcome } = useGetBusinessReportOutcomeQuery(snapshotOutcomeId ?? "", {
    skip: !snapshotOutcomeId,
  });

  React.useEffect(() => {
    if (outcome && !outcome.snapshot_collection_id) {
      toast.error("Source snapshot is not linked to a collection — cannot open the detail view.");
      setCurrentSnapshotCitation(null);
    }
  }, [outcome, setCurrentSnapshotCitation]);

  if (!currentSnapshotCitation || !outcome || !outcome.snapshot_collection_id) {
    return null;
  }

  const result = outcome.result.find(r => r.id === currentSnapshotCitation.outcomeResultId);

  return (
    <SnapshotGridPortal
      isOpen
      setIsOpen={isOpen => {
        if (!isOpen) {
          setCurrentSnapshotCitation(null);
        }
      }}
      businessReportOutcome={outcome}
      result={result}
      snapshotCollectionId={outcome.snapshot_collection_id}
      initialTab="pdfViewer"
      isCitationView
    />
  );
};
